export enum CancellationReasonOptionsInPerson {
  'Patient improved' = 'Patient improved',
  'Wait time too long' = 'Wait time too long',
  'Prefer another provider' = 'Prefer another provider',
  'Changing location' = 'Changing location',
  'Changing to telemedicine' = 'Changing to telemedicine',
  'Financial responsibility concern' = 'Financial responsibility concern',
  'Insurance issue' = 'Insurance issue',
  'Service never offered' = 'Service never offered',
  'Duplicate visit or account error' = 'Duplicate visit or account error',
  'Provider deems acuity too high for clinic' = 'Provider deems acuity too high for clinic',
}

export const CancellationReasonCodesInPerson: { [key in CancellationReasonOptionsInPerson]: string } = {
  'Patient improved': 'patient-improved',
  'Wait time too long': 'wait-time',
  'Prefer another provider': 'prefer-another-provider',
  'Changing location': 'changing-location',
  'Changing to telemedicine': 'changing-telemedicine',
  'Financial responsibility concern': 'financial-concern',
  'Insurance issue': 'insurance-issue',
  'Service never offered': 'service-not-offered',
  'Duplicate visit or account error': 'duplicate-visit-or-account-error',
  'Provider deems acuity too high for clinic': 'provider-deems-acuity-too-high-for-clinic',
};
